import { render, staticRenderFns } from "./ChatWindow.vue?vue&type=template&id=aef19fd0&scoped=true"
import script from "./ChatWindow.vue?vue&type=script&lang=js"
export * from "./ChatWindow.vue?vue&type=script&lang=js"
import style0 from "./ChatWindow.vue?vue&type=style&index=0&id=aef19fd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef19fd0",
  null
  
)

export default component.exports